import Loading from 'quasar/src/plugins/loading/Loading.js';import openURL from 'quasar/src/utils/open-url/open-url.js';
import { FindFileItemCommand, FindFilesInfoCommand } from "src/api/Common/Commands/FindFilesInfoCommand";
import { FileHelper } from "src/extensions/utils/FileHelper";
import { computed, defineComponent, ref, toRefs, watch } from "vue";
import { api } from "~/api";
import { GetFilesCommand } from "~/api/Common/Commands/GetFilesCommand";
import { FindFilesInfoResult } from "~/api/data/Common/FindFIlesInfoResult";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import BukenRoomList from "~/components/BukenRoomList.vue";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
import { FileCode, FileFetchKb, PageID, RoomSb } from "~/extensions/utils/DefineTypes";
import { commonStore } from "~/store/CommonStore";
import { myPageStore } from "~/store/MyPageStore";
import { useLoad } from "./composition/Load";
import { store } from "./store/NyukyoStore";
const log = Log.create("NyukyoInfoPage");
export default defineComponent({
    name: "NyukyoInfoPage",
    components: {
        BukenRoomList,
        BreadcrumbList
    },
    setup() {
        const { load, loading } = useLoad();
        const nyukyokeiyaku = computed(() => myPageStore.selectedNyukyokeiyaku);
        const isParking = ref(false);
        //ファイル関連
        const commonFileCode = FileCode.NyukyoInfoCommonFile;
        const propertyFileCode = FileCode.NyukyoInfoPropertyFile;
        const setFileCode = FileCode.NyukyoInfoSetFile;
        const findFilesInfoCommand = new FindFilesInfoCommand();
        const getFilesCommand = new GetFilesCommand();
        const result = ref(new FindFilesInfoResult());
        const zipFile = ref(null);
        const propertyFileExists = ref(false);
        const setFileExists = ref(false);
        const isLifeLineElectricity = ref(false);
        const isLifeLineGas = ref(false);
        const isLifeLineWater = ref(false);
        const isPostDialNo = ref(false);
        const fileList = ref([]);
        // 画面名取得
        const pageName = commonStore.pageName(PageID.nyukyo);
        const initView = async () => {
            await fetchNyukyoInfo();
        };
        watch(() => myPageStore.selectedNyukyokeiyakuNo, async (newVal) => {
            if (!isNullOrUndefined(newVal) && newVal !== -1) {
                try {
                    await fetchNyukyoInfo();
                }
                catch (e) {
                    MsgBox.error(e.message);
                }
            }
        });
        const urlClicked = () => {
            openURL(store.nyukyo.gomiShushubiUrl);
        };
        const downloadFileByCode = async (fileCode) => {
            const target = fileList.value.find(f => f.fileCode === fileCode);
            if (!target || !target.fileNo == null) {
                return;
            }
            const fileData = await FileHelper.getFileFromZip(zipFile.value, target.fileNo);
            if (!fileData) {
                return;
            }
            FileHelper.downloadBlob(fileData.blob, fileData.fileName);
        };
        const fetchNyukyoInfo = async () => {
            try {
                Loading.show();
                await load(nyukyokeiyaku.value.nyukyokeiyakuNo);
                isLifeLineElectricity.value = store.nyukyo.lifeLineElectricity === "";
                isLifeLineGas.value = store.nyukyo.lifeLineGas === "";
                isLifeLineWater.value = store.nyukyo.lifeLineWater === "";
                isPostDialNo.value = !store.nyukyo.postDialNo;
                isParking.value = nyukyokeiyaku.value.roomSb === RoomSb.Parking;
                // ファイル情報取得パラメータ設定
                findFilesInfoCommand.BuknCd = store.nyukyo.propertyCode;
                findFilesInfoCommand.OrgNyukyokeiyakuNo = store.nyukyo.orgNyukyokeiyakuNo;
                findFilesInfoCommand.fileList = [
                    new FindFileItemCommand(FileFetchKb.Reganam, FileCode.NyukyoInfoPropertyFile),
                    new FindFileItemCommand(FileFetchKb.Reganam, FileCode.NyukyoInfoSetFile),
                    new FindFileItemCommand(FileFetchKb.Server, FileCode.NyukyoInfoCommonFile)
                ];
                // ファイル情報取得
                result.value = await api.common.findFilesInfo(findFilesInfoCommand);
                const fileMap = new Map(findFilesInfoCommand.fileList.map(x => [x.fileCode, x.fileFetchKb]));
                // ファイル取得パラメータ設定
                getFilesCommand.BuknCd = store.nyukyo.propertyCode;
                getFilesCommand.OrgNyukyokeiyakuNo = store.nyukyo.orgNyukyokeiyakuNo;
                getFilesCommand.fileList = result.value.fileList.map(item => {
                    return {
                        fileNo: item.fileNo,
                        fileFetchKb: fileMap.get(item.fileCode) ?? 0,
                        fileCode: item.fileCode,
                        fileExists: item.fileExists
                    };
                });
                // ファイル取得
                const res = await api.common.getFiles(getFilesCommand);
                zipFile.value = res;
                // Zip内からファイル取得
                fileList.value = await FileHelper.getFilesFromZip(zipFile.value, result.value.fileList);
                // 取得したファイルの存在フラグを代入
                propertyFileExists.value = fileList.value.find(x => x.fileCode === FileCode.NyukyoInfoPropertyFile)?.fileExists ?? false;
                setFileExists.value = fileList.value.find(x => x.fileCode === FileCode.NyukyoInfoSetFile)?.fileExists ?? false;
            }
            catch {
            }
            finally {
                Loading.hide();
            }
        };
        initView();
        return {
            ...toRefs(store),
            ...useLoad(),
            myPageStore,
            nyukyokeiyaku,
            fileList,
            propertyFileExists,
            setFileExists,
            commonFileCode,
            propertyFileCode,
            setFileCode,
            isParking,
            isLifeLineElectricity,
            isLifeLineGas,
            isLifeLineWater,
            isPostDialNo,
            pageName,
            PageID,
            loading,
            urlClicked,
            load,
            downloadFileByCode
        };
    }
});
